import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  effect,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { FormsModule } from '@angular/forms';
import { TransactionStatus } from '../../shared/schemas/transaction';
import { BossServicesService } from '../../shared/services/boss-services.service';
import { Transaction } from '../../shared/schemas/transaction';
import { BusinessService } from '../../shared/services/business.service';
import { TransactionService } from '../../shared/services/transaction.service';
import { AllServicesComponent } from '../../shared/ui/all-services/all-services.component';
import { AmountSummaryPipe } from '../../shared/utils/pipes/amount-summary.pipe';
import { ModalService } from '../../shared/utils/services/modal.service';
import { TransactionListComponent } from './ui/transaction-list/transaction-list.component';
import { TransactionsBreakdownComponent } from './ui/transactions-breakdown/transactions-breakdown.component';

@Component({
  selector: 'qwiko-transactions',
  imports: [
    CommonModule,
    RouterModule,
    TranslocoModule,
    FormsModule,
    TransactionsBreakdownComponent,
    AmountSummaryPipe,
    AllServicesComponent,
    TransactionListComponent,
  ],
  templateUrl: './transactions.page.html',
  styleUrl: './transactions.page.scss',
})
export class TransactionsPage implements OnInit {
  modalService = inject(ModalService);
  transactionServices = inject(TransactionService);
  businessService = inject(BusinessService);
  private services = inject(BossServicesService);
  transactionStatus = TransactionStatus;
  transactions = this.transactionServices.transactions;
  loadedTransactions = this.transactionServices.loadedTransactions;
  transactionCount = this.transactionServices.transactionCount;
  businessPaymentAccounts = this.businessService.businessPaymentAccounts;
  filterIsOpen = signal<boolean>(false);

  initiatedTransactions = signal<number>(0);
  initiatedTransactionsEffect = effect(() => {
    if (this.transactionServices.loadedTransactions()) {
      const initiated = this.transactions().filter((transaction) => {
        return transaction.status === this.transactionStatus.INITIATED;
      });
      this.initiatedTransactions.set(initiated.length);
    }
  });

  confirmedTransactions = signal<number>(0);
  confirmedTransactionsEffect = effect(() => {
    if (this.transactionServices.loadedTransactions()) {
      const confirmedTransactions = this.transactions().filter(
        (transaction) => {
          return transaction.status === this.transactionStatus.CONFIRMED;
        },
      );
      this.confirmedTransactions.set(confirmedTransactions.length);
    }
  });

  canceledTransactions = signal<number>(0);
  canceledTransactionsEffect = effect(() => {
    if (this.transactionServices.loadedTransactions()) {
      const canceledTransactions = this.transactions().filter((transaction) => {
        return transaction.status === this.transactionStatus.CANCELED;
      });
      this.canceledTransactions.set(canceledTransactions.length);
    }
  });

  pendingTransactions = signal<number>(0);
  pendingTransactionsEffect = effect(() => {
    if (this.transactionServices.loadedTransactions()) {
      const pendingTransactions = this.transactions().filter((transaction) => {
        return transaction.status === this.transactionStatus.PENDING;
      });
      this.pendingTransactions.set(pendingTransactions.length);
    }
  });

  selectedTransaction = signal<Transaction | null>(null);
  loading = signal<boolean>(true);
  statusFilter = signal<TransactionStatus>(this.transactionStatus.ALL);
  accountsFilter = signal<string>('all');

  filterEffect = effect(() => {
    if (this.statusFilter() || this.accountsFilter()) {
      this.filterIsOpen.set(false);
    }
    if (this.accountsFilter()) {
      this.filterIsOpen.set(false);
    }
  });

  async ngOnInit(): Promise<void> {
    // this.loading.set(true);
    // await new Promise((resolve) => setTimeout(resolve, 3000));
    await this.transactionServices.getTransactions();
    this.loading.set(false);
  }

  recordPayment() {
    this.modalService.closeAll();
    this.services.isRecordPayment.set(true);
  }

  showTransaction(transaction: Transaction) {
    this.modalService.open('transaction-details-modal');
    this.selectedTransaction.set(transaction);
    console.log(transaction);
  }
  showTransactionBreakdown() {
    this.modalService.open('transactions-breakdown');
  }

  openModal(modal: string) {
    this.modalService.open(modal);
  }

  closeModal(modal: string) {
    this.modalService.close(modal);
  }
}
